import useMediaQuery from '@material-ui/core/useMediaQuery';
import { isMobile as isMobileDevice } from 'react-device-detect';

/**
 * @returns True if the device is mobile or the viewport is no wider than maxWidth.
 */
export const useIsMobile = (maxWidth = 600) => {
  const narrowViewport = useMediaQuery(`(max-width:${maxWidth}px)`);
  return isMobileDevice || narrowViewport;
};
